import { render, staticRenderFns } from "./color-cell.vue?vue&type=template&id=122792f9&scoped=true"
import script from "./color-cell.vue?vue&type=script&lang=js"
export * from "./color-cell.vue?vue&type=script&lang=js"
import style0 from "./color-cell.vue?vue&type=style&index=0&id=122792f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122792f9",
  null
  
)

export default component.exports